import {
  START_FETCHING_DRIVERS,
  FETCHING_DRIVERS_SUCCESS,
  FETCHING_DRIVERS_ERROR,
} from '@app/actions/api-drivers';
import { SET_DRIVER_ID } from '@app/actions/drivers';

const initialState = {
  all: [],
  driverSelectedId: '',
};

const drivers = (state = initialState, action) => {
  switch (action.type) {
    case START_FETCHING_DRIVERS:
      return {
        ...initialState,
      };

    case FETCHING_DRIVERS_SUCCESS:
      return {
        ...state,
        all: action.drivers,
      };

    case FETCHING_DRIVERS_ERROR:
      return state;

    case SET_DRIVER_ID:
      return {
        ...state,
        driverSelectedId: action.driverId,
      };

    default:
      return state;
  }
};

export default drivers;



// WEBPACK FOOTER //
// ./src/reducer/drivers.js